import actionType from '../actions/stock/actionType';

const initialState: any = {
  // 实时库存
  storeRealtimeStockLoading: false,
  realtimeStockData: {},

  // 房间常驻库存
  roomPermanentStockLoding: false,
  roomPermanentStockData: {},

  // 商品列表
  getGoodsListLoading: false,
  stockGoodsList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case actionType.UPDATE_STOCK_LIST:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
